import {
    Button,
    IconButton,
    TableCell,
    TableRow,
    withStyles,
} from '@material-ui/core';
import React from 'react';
export const VendorTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        padding: '8px 8px',
        borderTop: '1px solid #EBEDF8',
        borderBottom: '1px solid #EBEDF8',
        '&:first-child': {
            paddingLeft: '16px',
            borderTopLeftRadius: '4px',
            borderBottomLeftRadius: '4px',
            borderLeft: '1px solid #EBEDF8',
        },
        '&:last-child': {
            paddingRight: '16px',
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px',
            borderRight: '1px solid #EBEDF8',
        },
    },
}))(TableCell);
interface VendorRowProps {
    row: any;
    columns: any[];
    getColumnComponentValue: (row: any, column: any, handleAction: any) => any;
    onClick?: (event: any, row: any) => void;
}

// Hover styling lives here rather than as a className prop so VendorRow's memo
// inputs stay unchanged.
const VendorStyledRow = withStyles(() => ({
    root: {
        transition: 'background-color 0.15s ease-in-out',
        '&:hover': {
            backgroundColor: '#f7f8ff',
        },
    },
}))(TableRow);

/**
 * Memoized so paging/searching only re-renders the rows that actually changed.
 */
export const VendorRow = React.memo(
    ({ row, columns, getColumnComponentValue, onClick }: VendorRowProps) => (
        <VendorStyledRow onClick={(event: any) => onClick?.(event, row)}>
            {columns?.map((column: any, index: any) => (
                <VendorTableCell key={`row${index}`}>
                    {getColumnComponentValue(row, column, null)}
                </VendorTableCell>
            ))}
        </VendorStyledRow>
    ),
);

export const VendorTableHeadCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: '#525050',
        fontWeight: 700,
        fontSize: 14,
        letterSpacing: '0.144px',
        textTransform: 'capitalize',
        padding: '8px',
        borderBottom: '1px solid #EBEDF8',
        whiteSpace: 'nowrap',
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
export const ActionIcon = withStyles(() => ({
    root: {
        border: '1px solid transparent',
        '&:hover': {
            backgroundColor: '#fff !important',
            border: '1px solid #c7c6e2 !important',
        },
    },
    rootDelete: {
        color: 'red',
        border: '1px solid transparent',
        '&:hover': {
            border: '1px solid #c7c6e2',
            backgroundColor: 'red',
            color: '#fff',
        },
    },
}))(({ classes, isDelete, useButton = false, ...props }: any) =>
    !!useButton ? (
        <Button
            classes={{
                root: !!isDelete ? classes.rootDelete : classes.root,
            }}
            {...props}
        >
            {props.children}
        </Button>
    ) : (
        <IconButton
            classes={{
                root: !!isDelete ? classes.rootDelete : classes.root,
            }}
            {...props}
        >
            {props?.children}
        </IconButton>
    ),
);

